import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React,{Component} from 'react';
import firebase from 'firebase';
import {Link} from 'react-router-dom';
import store from '../../store';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const moment = require('moment');


const database=firebase.database();


class ReporteVehiculos extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			
			vehiculos:[],
			vehiculostemp:[],
			socios:[],
			bases:[],
			labels:['Marca','Modelo','Placa','Estado','Socio','Año','Base','Tipo']
			
		}
		
		
		this.sociosRef=database.ref().child('Socios');
		this.basesRef=database.ref().child('Bases');
		this.vehiculosRef=database.ref().child('Vehiculos');
		this.onKeyUpFilter=this.onKeyUpFilter.bind(this);
		this.handleClickPrint=this.handleClickPrint.bind(this);
		
		
	}
	
	
	componentDidMount(){
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);		
		
		
	}

	componentWillMount(){		
		this.sociosRef.once('value',this.gotDataSocios,this.errDataSocios);		

	}

		
	gotDataSocios=(data)=>{
			
		let newSocios=[];
		
		if(data.val()!==null){
			
			let socio=data.val();
			let keys=Object.keys(socio);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
								
				if(socio[k].Nombre!==undefined){
					
					newSocios.push({
						key:k,
						nombre:socio[k].Nombre,
						apellido:socio[k].Apellido,
						estado:socio[k].Estado						
					})
				}
				
			}
			this.setState({socios:newSocios});			
			this.basesRef.once('value',this.gotDataBases,this.errDataBases);
		}		
	}
	errDataSocios=(err)=>{
		
		console.log(err);
		
	}
	
	gotDataBases=(data)=>{
	

		let newBases=[]
	
		if(data.val()!==null){
			
			let base=data.val();
			let keys=Object.keys(base);
			
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				
				if(base[k].Nombre!==undefined){
					
					
					newBases.push({
						key:k,
						nombre:base[k].Nombre,
						direccion:base[k].direccion,
						descripcion:base[k].Descripcion
						
					})
					
				}
				
			}
			this.setState({bases:newBases});
			this.vehiculosRef.once('value',this.gotData,this.errData);
			
		}
		
		
	}
	errDataBases=(err)=>{
		
		console.log(err);
		
	}
	

	
	
gotData=(data)=>{
		
		let newVehiculos=[];
		
		if(data.val()!==null){
			
			let data_vehiculos=data.val();
			
			let keys=Object.keys(data_vehiculos);
			
			for(let i=0;i<keys.length;i++){
				
				
				let k=keys[i];
				
				let nombre_base;
				let nombre_socio;
				
				
				for(let j=0;j<this.state.socios.length;j++){
					
					
					if(data_vehiculos[k].codigo_socio===this.state.socios[j].key){
						
						nombre_socio=this.state.socios[j].nombre+' '+this.state.socios[j].apellido;
						
					}
					
				}
				
				for(let h=0;h<this.state.bases.length;h++){
					
					
					if(data_vehiculos[k].base===this.state.bases[h].key){
						
						nombre_base=this.state.bases[h].nombre;
					}
					
				}
				
				
				
				if(data_vehiculos[k].marca!==undefined){
					
					if(nombre_socio !== undefined){
						newVehiculos.push({
							key:k,
							base:nombre_base,
							marca:data_vehiculos[k].marca,
							modelo:data_vehiculos[k].modelo,
							estado:data_vehiculos[k].estado,
							socio:nombre_socio,
							anio:data_vehiculos[k].anio,
							placa:data_vehiculos[k].placa,
							tipo_vehiculo:data_vehiculos[k].tipo_vehiculo
							
						})
					}
				}
				
				
			}
			this.setState({
				vehiculos:newVehiculos,
				vehiculostemp:newVehiculos
			});
				
			
		}
		
	}
	errData=(err)=>{
		
		console.log(err);
		
	}

	
	onKeyUpFilter(){
		
			let newVehiculos=[]
		
			let marca=this.marca.value;
			let modelo=this.modelo.value;
			let estado=this.estado.value;
			let socio=this.socio.value;
			let base=this.base.value;
			let tipo_vehiculo=this.tipo_vehiculo.value;
		
		
			this.state.vehiculos=this.state.vehiculostemp;
			this.setState({
				
				vehiculos:this.state.vehiculostemp
				
			})
		
		
			for(let i=0;i<this.state.vehiculos.length;i++){
				
				
				let marca_filter=this.state.vehiculos[i].marca.toLowerCase().search(marca.toLowerCase())>=0 ?true:false;
				let modelo_filter=this.state.vehiculos[i].modelo.toLowerCase().search(modelo.toLowerCase())>=0?true:false;
				let estado_filter=this.state.vehiculos[i].estado.toLowerCase().search(estado.toLowerCase())>=0?true:false;
				let socio_filter=this.state.vehiculos[i].socio.toLowerCase().search(socio.toLowerCase())>=0?true:false;
				let tipo_vehiculo_filter=this.state.vehiculos[i].tipo_vehiculo.toLowerCase().search(tipo_vehiculo.toLowerCase())>=0?true:false;
				
				
				if(marca_filter && modelo_filter && estado_filter && socio_filter && tipo_vehiculo_filter){
					
					newVehiculos.push({
						
						key:this.state.vehiculos[i].key,
						base:this.state.vehiculos[i].base,
						marca:this.state.vehiculos[i].marca,
						modelo:this.state.vehiculos[i].modelo,
						estado:this.state.vehiculos[i].estado,
						socio:this.state.vehiculos[i].socio,
						anio:this.state.vehiculos[i].anio,
						placa:this.state.vehiculos[i].placa,
						tipo_vehiculo:this.state.vehiculos[i].tipo_vehiculo
						
						
						
					})
					
					
					
				}
				
			}
			
			this.state.vehiculos=newVehiculos
			this.setState({
				
				vehiculos:newVehiculos
			})
		
	}
	
	handleClickPrint() {

		const tempArr = [];
		for (var i = 0; i < this.state.vehiculos.length; i++) {

			tempArr.push(
				[
					this.state.vehiculos[i].marca,
					this.state.vehiculos[i].modelo,
					this.state.vehiculos[i].placa,
					this.state.vehiculos[i].estado,
					this.state.vehiculos[i].socio,
					this.state.vehiculos[i].anio,
					this.state.vehiculos[i].base,
					this.state.vehiculos[i].tipo_vehiculo
				]
			);
		}

		const dd = {
			content: [{
				text: ''
			},
			{
				text: 'Reporte de vehículos',
				style: 'header'
			},
			{
				text: moment().format('LLLL'),
				style: 'myStyle'
			},
			{
				table: {
					headerRows: 1,
					widths: '*',
					body: [
						[{ text: 'Marca', bold: true }, { text: 'Modelo', bold: true }, { text: 'Placa', bold: true }, { text: 'Estado', bold: true }, { text: 'Socio', bold: true }, { text: 'Año', bold: true }, { text: 'Base', bold: true },  { text: 'Tipo de vehiculo', bold: true }],
						...tempArr
					],
				}
			}
			],
			styles: {
				header: {
					fontSize: 25,
					bold: true,
					alingContent: 'right'
				},
				myStyle: {
					fontSize: 9,
					margin: [0, 10, 0, 10]
				},
			}
		}
		pdfMake.createPdf(dd).download('reporteVehiculos');
	}
	
	
	render(){
		
		return(
		
				<div className="reporte_vehiculos">
				
					<center><h3>Reporte de vehiculos</h3></center>
					
					
					
					<a className="btn btn-success" onClick={this.handleClickPrint}><span class="glyphicon glyphicon-print" style={{color:"white"}}> Imprimir</span></a>
					<div className="row">
						
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="marca">Marca</label>
								<input type="text" name="marca" placeholder="Marca" className="form-control"
									ref={input=>{this.marca=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="modelo">Modelo</label>
								<input type="text" name="modelo" placeholder="Modelo" className="form-control"
									ref={input=>{this.modelo=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="estado">Estado</label>
								<input type="text" name="estado" placeholder="Estado" className="form-control"
									ref={input=>{this.estado=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div> 
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="socio">Socio</label>
								<input type="text" name="socio"  placeholder="Socio" className="form-control"
									ref={input=>{this.socio=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>						
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="base">Base</label>
								<input type="text" name="base" placeholder="Base" className="form-control"
									ref={input=>{this.base=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>
						</div>
						<div className="col-md-2">
							<div className="form-group">
								<label htmlFor="tipo_vehiculo">Tipo de vehiculo</label>
								<input type="text" name="tipo_vehiculo" placeholder="Tipo vehiculo" className="form-control"
									ref={input=>{this.tipo_vehiculo=input;}}
									onKeyUp={this.onKeyUpFilter}
								/>
							</div>
						</div>
						
					
					</div>
				
					<BootstrapTable data={ this.state.vehiculos }
								 ref='table'			 
								 pagination={ true }
								 search={ false }
								 hover
								 >
								 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
								 <TableHeaderColumn dataField='marca'  dataSort={true}  >Marca</TableHeaderColumn>
								 <TableHeaderColumn dataField='modelo'  dataSort={true}  >Modelo</TableHeaderColumn>
								 <TableHeaderColumn dataField='placa'  dataSort={true}  >Placa</TableHeaderColumn>
								 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>								 
								 <TableHeaderColumn dataField='socio'  dataSort={true}  >Socio</TableHeaderColumn>
								 <TableHeaderColumn dataField='anio'  dataSort={true}  >Año</TableHeaderColumn>
								 <TableHeaderColumn dataField='base'  dataSort={true}  >Base</TableHeaderColumn>				
								 <TableHeaderColumn dataField='tipo_vehiculo'  dataSort={true} >Tipo de vehiculo</TableHeaderColumn>				
					</BootstrapTable>
				
				
				
				</div>
		
		)
		
		
	}
	
	
}

export default ReporteVehiculos;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ReporteVehiculos.jsx